import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'coalesceTo'
})

export class CoalesceToPipe implements PipeTransform {
  transform<T, R>(value: T, result: R) {
    return value ?? result;
  }
}
